import { Badge } from "@/components/ui/badge";
import type { ProgramNewsItem } from "@/services/adminProgramNews";
import { classBadgeVariant } from "./deliveryClass";
import { REASON_NOT_RECORDED } from "./glossary";
import Term from "./Term";

interface ReasonLineProps {
  item: ProgramNewsItem;
  /** One truncated line under the title (row) or the full text (detail). */
  full?: boolean;
}

/** Why an article got its label; nothing for new/failed rows. */
const ReasonLine = ({ item, full = false }: ReasonLineProps) => {
  const clamp = full ? "break-words" : "truncate";
  if (item.processingStatus === "suppressed") {
    const reason = item.suppressedReason || item.rawMetadata?.classification?.rationale;
    return reason ? (
      <div className={`text-xs text-muted-foreground ${clamp}`} title={reason}>
        {reason}
      </div>
    ) : (
      <div className="text-xs italic text-muted-foreground">{REASON_NOT_RECORDED}</div>
    );
  }
  if (item.processingStatus === "classified") {
    if (!item.classificationRationale && !item.classifiedOutcome) {
      return <div className="text-xs italic text-muted-foreground">{REASON_NOT_RECORDED}</div>;
    }
    return (
      <div className="flex items-center gap-1 text-xs text-muted-foreground">
        {item.classifiedOutcome ? (
          <Badge variant={classBadgeVariant(item.classifiedOutcome)}>
            <Term term={item.classifiedOutcome}>{item.classifiedOutcome}</Term>
          </Badge>
        ) : null}
        {item.classificationRationale ? (
          <span className={clamp} title={item.classificationRationale}>
            {item.classificationRationale}
          </span>
        ) : (
          <span className="italic">{REASON_NOT_RECORDED}</span>
        )}
      </div>
    );
  }
  return null;
};

export default ReasonLine;
